import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import TimezoneSelectField from 'dashboard/components/FormControls/TimezoneSelectField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Section from 'dashboard/layouts/FormLayout/Section';
import { Organization } from 'dashboard/models/organization';
import Button from 'design-system/components/Button';
import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';
import { isRequired, Rule, withMessage } from 'lib/utils/formValidation';

const validate: Record<keyof FormOrganizationDetailsData, Rule[]> = {
  name: [withMessage('Please enter your organization name', isRequired)],
  timezone: [],
};

const FormOrganizationDetails = ({ handleSubmit, submitting, pristine }: InjectedFormProps) => {
  const hasEditPermission = usePermission(Permission.OrganizationWrite);

  return (
    <Form onSubmit={handleSubmit}>
      <Section cols={2} colsMobile={1}>
        <Field
          component={InputField}
          name='name'
          id='name'
          type='text'
          data-test='form-organization-details__organization-name'
          disabled={!hasEditPermission || submitting}
          validate={validate['name']}
          placeholder='Acme Inc.'
          label='Organization name'
        />

        <Field
          component={TimezoneSelectField}
          name='timezone'
          id='timezone'
          placeholder='Timezone'
          data-test='form-organization-details__organization-timezone'
          disabled={!hasEditPermission || submitting}
          label='Default User Time Zone'
        />
      </Section>

      {hasEditPermission && (
        <Section cols={3} colsMobile={1}>
          <Button
            type='submit'
            data-test='form-organization-details__save'
            disabled={submitting || pristine}
            isPending={submitting}
          >
            Save changes
          </Button>
        </Section>
      )}
    </Form>
  );
};

export type FormOrganizationDetailsData = Pick<Organization['attributes'], 'name' | 'timezone'>;

export const FORM_ORGANIZATION_DETAILS_NAME = 'formOrganizationDetails';

export default reduxForm<FormOrganizationDetailsData, {}>({
  form: FORM_ORGANIZATION_DETAILS_NAME,
  enableReinitialize: true,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormOrganizationDetails);
